import React, { useEffect, useState } from "react";
import {
  Alert, Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner,
} from "reactstrap";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

/**
 * İlan / mezat / değerleme sahibine admin uyarısı ("yanlış mezat açtın" vb.)
 * ve tek tıkla arama / WhatsApp. Bildirim api/AdminBildirim/TopluGonder
 * (HedefTip "user") ile gider: BILDIRIM_LOGLARI'na yazılır + push; push'a
 * dokununca uygulama ilgili ilanı/mezatı açar.
 *
 * tip: "ILAN" | "MEZAT" | "DEGERLEME"
 */
const HAZIR_METINLER = {
  ILAN: [
    { baslik: "İlanınız hakkında", mesaj: "İlanınız yanlış kategoride görünüyor, lütfen kategorisini düzeltin." },
    { baslik: "İlanınız hakkında", mesaj: "İlanınızdaki fotoğraflar yetersiz/uygunsuz, lütfen güncelleyin." },
    { baslik: "İlanınız hakkında", mesaj: "İlan fiyatı veya açıklaması hatalı görünüyor, lütfen kontrol edin." },
  ],
  MEZAT: [
    { baslik: "Mezatınız hakkında", mesaj: "Mezatınızı yanlış açtınız (kategori/süre/başlangıç fiyatı). Lütfen kontrol edin veya bizimle iletişime geçin." },
    { baslik: "Mezatınız hakkında", mesaj: "Mezatınızın görselleri/videosu yetersiz, lütfen güncelleyin." },
  ],
  DEGERLEME: [
    { baslik: "Değerleme talebiniz hakkında", mesaj: "Değerleme talebinizde eksik bilgi var, lütfen fotoğraf ve açıklama ekleyin." },
    { baslik: "Değerleme talebiniz hakkında", mesaj: "Değerleme talebinizi yanlış açtınız. Satış için normal ilan vermeniz gerekiyor." },
  ],
};

const EKRAN = { ILAN: "ProductDetail", MEZAT: "LiveAuctionScreen", DEGERLEME: "ProductDetail" };

const telefonTemizle = tel => {
  let d = String(tel || "").replace(/\D/g, "");
  if (d.startsWith("90")) d = d.slice(2);
  if (d.startsWith("0")) d = d.slice(1);
  return d.length === 10 ? d : null;
};

const KullaniciIletisimModal = ({ isOpen, toggle, tip = "ILAN", ilgiliId, ilgiliBaslik, kullanici }) => {
  const [baslik, setBaslik] = useState("");
  const [mesaj, setMesaj] = useState("");
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [sonuc, setSonuc] = useState(null); // { renk, metin }

  useEffect(() => {
    if (!isOpen) return;
    const ilk = HAZIR_METINLER[tip]?.[0];
    setBaslik(ilk?.baslik || "");
    setMesaj("");
    setSonuc(null);
  }, [isOpen, tip]);

  const kullaniciId = kullanici?.ID;
  const tel = telefonTemizle(kullanici?.CEP_NO);

  const gonder = async () => {
    if (!kullaniciId) return setSonuc({ renk: "danger", metin: "Kullanıcı bilgisi yok." });
    if (!baslik.trim() || !mesaj.trim()) return setSonuc({ renk: "warning", metin: "Başlık ve mesaj zorunlu." });
    setGonderiliyor(true);
    try {
      const res = await fetch(`${BASE_URL}/api/AdminBildirim/TopluGonder`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({
          HedefTip: "user",
          KullaniciId: kullaniciId,
          Baslik: baslik.trim(),
          Icerik: ilgiliBaslik ? `${mesaj.trim()}\n(${ilgiliBaslik})` : mesaj.trim(),
          Tip: "SistemBildirim",
          Ekran: EKRAN[tip],
          IlgiliId: ilgiliId || null,
        }),
      });
      if (res.ok) {
        setSonuc({ renk: "success", metin: "Bildirim gönderildi." });
        setMesaj("");
      } else {
        let m = "Gönderilemedi.";
        try {
          const j = await res.json();
          m = j?.Message || j?.message || (typeof j === "string" ? j : m);
        } catch (_) {}
        setSonuc({ renk: "danger", metin: m });
      }
    } catch (e) {
      setSonuc({ renk: "danger", metin: "Bağlantı hatası." });
    } finally {
      setGonderiliyor(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        Kullanıcıyla İletişim — {kullanici?.AD_SOYAD || `#${kullaniciId ?? "?"}`}
      </ModalHeader>
      <ModalBody>
        <div className="d-flex gap-2 mb-3 flex-wrap">
          <Button color="success" outline size="sm" disabled={!tel} href={tel ? `tel:+90${tel}` : undefined}>
            <i className="bx bx-phone me-1" /> {tel ? `Ara: 0${tel}` : "Telefon yok"}
          </Button>
          <Button
            color="success" size="sm" disabled={!tel} target="_blank" rel="noreferrer"
            href={tel ? `https://wa.me/90${tel}?text=${encodeURIComponent(mesaj || "")}` : undefined}
          >
            <i className="bx bxl-whatsapp me-1" /> WhatsApp
          </Button>
        </div>

        <Label className="mb-1">Hazır mesajlar</Label>
        <div className="d-flex flex-column gap-1 mb-3">
          {(HAZIR_METINLER[tip] || []).map((h, i) => (
            <Button key={i} color="light" size="sm" className="text-start"
              onClick={() => { setBaslik(h.baslik); setMesaj(h.mesaj); }}>
              {h.mesaj}
            </Button>
          ))}
        </div>

        <Label className="mb-1">Başlık</Label>
        <Input value={baslik} onChange={e => setBaslik(e.target.value)} maxLength={100} className="mb-2" />
        <Label className="mb-1">Mesaj</Label>
        <Input type="textarea" rows={4} value={mesaj} onChange={e => setMesaj(e.target.value)} maxLength={500} />
        <small className="text-muted">
          Bildirim uygulamaya push olarak gider; dokununca ilgili {tip === "MEZAT" ? "mezat" : "ilan"} açılır.
        </small>
        {sonuc && <Alert color={sonuc.renk} className="mt-3 mb-0">{sonuc.metin}</Alert>}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Kapat</Button>
        <Button color="primary" onClick={gonder} disabled={gonderiliyor}>
          {gonderiliyor ? <Spinner size="sm" /> : "Bildirim Gönder"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default KullaniciIletisimModal;
